/**
 * Minimal shim for core-js-pure internals/export when the package ships without it.
 * Used so globalThis and other polyfills can attach to the global object.
 */
/* eslint-disable no-undef, no-restricted-globals */
function exportHelper(options, source) {
  if (options && options.global && source && typeof source === 'object') {
    var g = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : (function () { return this; })();
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        try {
          g[key] = source[key];
        } catch (e) { /* ignore */ }
      }
    }
  }
  return source;
}
module.exports = exportHelper;
